﻿import SharedHotEditableParentForm = require("./modules/vue/hotEditable/SharedHotEditableParentForm");
import MessagesManager = require("./modules/components/MessagesManager");
import Notifications = require("./modules/components/Notifications");
import Pooler = require("./core/Pooler");
import Page = require("./modules/components/Page");
import SharedEmbeddedParentForm = require("./modules/vue/hotEditable/SharedEmbeddedParentForm");
import SearchBox = require("./core/SearchBox");

namespace common {
    // ENUMERATIONS ===========================================================================
    export enum WebComponentTypes {
        unknown = "unknown",
        page = "page",
    }

    export enum ConfirmationCodes { 
        unset = 'unset',
        accepted = 'true',
        denied = 'false'
    } 
    export enum ConditionalClauses {
        and = 'and',
        or = 'or'
    }

    export enum SortOrderTypes {
        asc = 'asc',
        desc = 'desc',
        unset = 'unset'
    }

    export enum HotEditableFormModes {
        original = "original",
        edition = "edition"
    }
    export enum HotEditableFormMessageModes {
        unknown = "unknown",
        standard = "standard",
        field = "field",
    }

    export enum HotEditableMessageTypes {
        unknown = "unknown",
        info = "info",
        success = "success",
        warning = "warning",
        error = "error"
    }
    export enum urlOptions {
        unknown = "unknown",
        targetBlank = "targetBlank"
    }

    export enum HotEditableFieldTypes {
        checkbox = "checkbox",
        datePicker = "datePicker",
        select = "select",
        textbox = "textbox",
        imageUpload = "imageUpload",
        documentUpload = "documentUpload",
        tinymce = "tinymce",
        doubleSelect = "doubleSelect",
        address = "address",
        embeddedForm = "embeddedForm",
        hiddenField = "hiddenField"
    }

    /** Attention, utilise aussi dans HotEditableFormAction::setClickedButton */
    export enum HotEditableButtonTypes {
        back = "back",
        create = "create",
        delete = "delete",
        update = "update", //signifie aussi 'save'
        cancel = "cancel",
        clear = "clear",
        close = "close",
        apply = "apply",
        edit = "edit",
        add = "add",
        plus = "plus",
        search = "search",
        postpone = "postpone",
        goto = "goto",
        reinit = "reinit"
    }

    export enum HotEditableButtonOptions {
        none = 'none',
        fullWidth = 'fullWidth'
    }

    export enum HotEditableActionTypes {
        unknown = "unknown",
        create = "create",
        /** signifie aussi 'save' */
        update = "update",
        delete = "delete",
        cancel = "cancel",
        reset = "reset",
        apply = "apply"
    }

    export enum MessageTypes {
        unknown = "unknown",
        info = "info",
        error = "error",
        success = "success",
        warning = "warning",
        notification = "notification"
    }

    export enum MessageStatusTypes {
        unknown = 'unknown',
        read = 'read',
        unread = 'unread',
        deleted = 'deleted'
    }

    /** Utilise entre autre comme variant de classes css*/
    export enum PopupStates {
        unknown = '',
        opened = 'opened',
        closed = 'closed'
    }
    export enum CollapsorStates {
        opened = 'opened',
        closed = 'closed'
    }
    export enum ToolsBarSelectionRules {
        nothingSelect = 'NothingSelect',
        nothingOrSingleSelect = 'NothingOrSingleSelect',
        nothingOrMultiSelect = 'NothingOrMultiSelect',
        singleSelect = 'SingleSelect',
        multiSelect = 'MultiSelect',
        bannerAction = 'BannerAction'
    }
    export enum Cultures {
        fr = "fr",
        en = "en"
        // es = "es";
    }
    /** note: doit respecter la case, tel que cela est fait dans ToolsBarActionTypes.cs */
    export enum ToolsBarActionTypes {
        unknown = 'Unknown',
        selectAll = 'SelectAll',
        unselectAll = 'UnselectAll',
        add = 'Add',
        read = 'Read',
        edit = 'Edit',
        delete = 'Delete',
        import = 'Import',
        transfertToLeft = 'TransfertToLeft',
        transfertToRight = 'TransfertToRight',
        banner_Read = 'Banner_Read',
        banner_Edit = 'Banner_Edit',
        banner_Delete = 'Banner_Delete',
        banner_Apply = 'Banner_Apply',
        banner_File = 'Banner_File',
        banner_TransfertToLeft = 'Banner_TransfertToLeft',
        banner_TransfertToRight = 'Banner_TransfertToRight',
        // Specifics 
        spec_ImportMamrot = 'Spec_ImportMamrot',
        spec_ReadFederationsSpecialisees = 'Spec_ReadFederationsSpecialisees',
        spec_ReadProductions = 'Spec_ReadProductions',
        spec_EditMunicipalitesAssociees = 'Spec_EditMunicipalitesAssociees',
        spec_EditFederationsRegionalesAssociees = 'Spec_EditFederationsRegionalesAssociees',
        spec_ReadMunicipalitesAssociees = 'Spec_ReadMunicipalitesAssociees',
        spec_ReadFederationsRegionalesAssociees = 'Spec_ReadFederationsRegionalesAssociees',
        spec_ReadFermeGestionRegionale = 'Spec_ReadFermeGestionRegionale',
        spec_TransferSyndicatSpecialise = 'Spec_TransferSyndicatSpecialise',
        spec_SetupMuninipalite = 'Spec_SetupMuninipalite',
        spec_ProduceLienFdu = 'Spec_ProduceLienFdu'
    }

    export enum SearchBoxItemsSelectionTypes {
        nothing = "nothing",
        one = "one",
        many = "many"
    }

    export enum HotEditableAdditionalFieldContentValueTypes {
        unknown = 'unknown',
        messageInfo = 'messageInfo',
        messageInfoHtml = 'messageInfoHtml',
        messageWarn = 'messageWarn',
        messageWarnHtml = 'messageWarnHtml',
    }

    // Cette enum doit matcher avec TaskStatus.cs
    export enum TaskStatus {
        ok = "Ok",
        running = "Running",
        runningLong = "RunningLong",
        inError = "InError",
        jammed = "Jammed",
        unknown = "Unknown"
    }

    export enum IndicatorStatus {
        ok = "ok",
        warning = "warning",
        error = "error",
        default = "default"
    }

    // INTERFACES ===========================================================================

    export interface IKeyValue {
        key: string;
        value: string;
    }
    export interface ITacheAdministrativeType {
        name: string;
        title: string;
        icon: string;
    }
    export interface ITacheAdministrative {
        id: string;
        typeName: string;
        title: string;
        description: string;
        date: string;
        dateRaw: string;
        dateRappel: string;
        dateRappelRaw: string;
        icon: string;
        isDone: boolean;
        author: string;
        comments: ITacheAdministrativeCommentaire[];
        /** Adding/Editing */
        currentlyEditingItem?: boolean;
        currentlyAddingComment?: boolean;
        commentNewText?: string;
    }
    export interface ITacheAdministrativeCommentaire {
        tacheAdministrativeId: string;
        id: string;
        author: string;
        text: string;
        textRaw: string;
        date: string;
        dateRaw: string;
        currentlyEditingComment?: boolean;
        editedText?: string;
    }
    export interface IHotEditableEmbeddedComponent extends IHotEditableFieldComponent, IEmbeddedContentModel {
        /** Si 'nextUrl' est NULL, alors l'url sera celle definie par DEFAULT */
        update(nextUrl: string, urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void): void;
        restore(urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void): void;
        refresh(urlParameters?: {}, editModeOn?: boolean, finalEvalCallback?: () => void): void;
        isDefaultUrlLoadded(): boolean;
        refreshBrotherEmbeddedComponents(): void;
        restoreBrotherEmbeddedComponents(): void;
        ensureBrotherEmbeddedComponentsIsDefaultUrl(): void;
    }

    export interface IEmbeddedContentModel {
        elementName: string;
        idElement: string;
        navigationContextId: string;
        isVisible: boolean;
        defaultUrl?: string;
        category?: string;
        order?: number;
    }
    export interface IDimensions {
        width: number;
        height: number;
        top: number;
        left: number;
    }
    export interface IPoolable {
        /** Enrichir l'objet 'args' et retourner TRUE si l'objet doit etre poolé. Utiliser la propriete "info.iteration%n === 0" pour bypasser certain tour */
        onPooling(args: IPoolerFetchArguments, info: IPoolerInformations): boolean;
        /** Methode appele au success */
        onPoolingSuccess?(responseData?: IPoolingFetchResponseData): void;
        /** Methode appele lors d'erreur(s) */
        onPoolingError?(errors: IError[]): void;
    }

    export interface IPoolerInformations {
        frequencySec: number;
        iteration: number;
        poolingDate: Date;
        lastPoolingDate?: Date;
        poolingDateUtcString: string;
        lastPoolingDateUtcString?: string;
    }
    export interface IPoolerFetchArguments {
        iteration: number;
        lastPoolingDate?: string;
        poolingDate: string;
        currentUrl: string;
        messagesManagerFetchArgs: IMessagesManagerPoolingFetchArguments;
        searchBoxFetchArgs: ISearchBoxFetchArguments[];
        panneauAdministrationFetchArgs: IPanneauAdministrationFetchArguments;
    }

    export interface IPoolingFetchResponseData {
        messagesManagerData: IMessagesManagerPoolingFetchResponseData;
        searchBoxData: ISearchBoxPoolingFetchResponseData[];
        panneauAdministrationData: IPanneauAdministrationPoolingFetchResponseData;
    }

    /** Configurations permettant de definir des conditions afin de caracteriser un bouton de l'attribut 'disabled'. */
    export interface IHotFormDisabledButtonByDefaultFieldConfig {
        buttonName?: string;
        buttonNames?: string[];
        field?: IHotFormDisabledButtonByDefaultFieldRef;
        fields?: IHotFormDisabledButtonByDefaultFieldRef[];
        /** Valeurs : 'and' ou 'or' (default='or') */
        fieldsConditionalClause?: ConditionalClauses;
    }
    /** Sous-configurations permettant l'association entre un champ et un ou des boutons, et de lui definir une condition qui est fonction de sa valeur textuelle. */
    export interface IHotFormDisabledButtonByDefaultFieldRef {
        name: string;
        /** L'argument 'value' est la valeur textuelle trimmee et jamais null, alors que 'fieldValue' est la valeur textuelle brute. */
        condition: (value: string, fieldValue: string, fieldType: string) => boolean;
    }
    export interface IHotEditableFormPostArguments {
        posted_actionType?: string;
        posted_actionValue?: string;
        posted_formName?: string;
        posted_fieldName?: string;
        posted_currentUrl?: string;
        posted_currentCulture?: common.Cultures;
        posted_previousPageUrl?: string;
        posted_customData?: any;
        posted_bag?: string;
        posted_currentEmbeddedComponentName?: string;
        posted_isControlClick?: boolean;
        bypassIgnorerPersonneConfirmation?: boolean;
    }

    export interface IMessagesManagerPoolingFetchResponseData {
        messages: IMessage[];
        totalUnreadNotifications: number;
    }

    export interface IMessagesManagerPoolingFetchArguments {
        doUpdate?: boolean;
    }
    export interface ISearchBoxAction {
        type: ToolsBarActionTypes;
        selectionRule: ToolsBarSelectionRules;
        /** determine si l'action est visible (ou cachee) */
        isVisible: boolean;
        /** determine si l'action disponible (ou grisee) */
        isEnable: boolean;
        title: string;
        toolTip: string;
        confirmationTitleHtml: string;
        confirmationMessageHtml: string;
    }


    export interface ISearchBoxPoolingFetchResponseData {
        contextName: string;
        applyRefresh: boolean;
        confirmationHtmlTitle: string;
        confirmationHtmlMessage: string;
        searchParameters: ISearchParameters;
        preconfiguredFilters?: ISearchBoxPreconfiguredFilters[];
    }

    export interface IButtonClickContext {
        name?: string;
        isCtlClick?: boolean;
    }

    export interface IPanneauAdministrationPoolingFetchResponseData {
        synchroStatusCode: string;
        synchroStatusDescription: string;
        synchroCurrentStep: string;
        isFermeCacheReady: boolean;
        fermeCacheStatusDescription: string;
    }

    export interface ISearchBoxFetchArguments {
        currentTotalItem: number;
        currentMaxModifiedResultDateUtc?: string;
        searchBoxArguments: ISearchBoxArguments;
    }

    export interface IPanneauAdministrationFetchArguments {
        doUpdate?: boolean;
    }

    export interface IPostCustomData {
        stringValues?: {}
        guidValues?: {}
        floatValues?: {}
        intValues?: {}
    }

    export interface IMessageClickResponseData {
        url?: string;
        bag?: IBag
    }

    /** Optionel: identifiant du message (sera automatiquement assigne si NULL) */
    export interface IMessage {
        /** optionel: id de reference */
        id?: string;
        /** Optionel: titre du message */
        title?: string;
        /** Optionel: contenu RTF (HTML) */
        contentHtml?: string;
        /** Optionel: url du lien */
        linkUrl?: string;
        /** Optionel: text du lien */
        linkText?: string;
        /** Optionel: determine si le lien doit etre ouvert dans un nouvel onglet (target='_blank') */
        linkAsBlank?: boolean;
        /** Optionel: url du click du message */
        clickUrl?: string;
        /** Optionel: attribut HTML 'title' au 'hover' du message  */
        clickToolTip?: string;
        /** Optionel: determine si le click doit ouvrir l'url dans un nouvel onglet (target='_blank') */
        clickAsBlank?: boolean;
        /** Optionel: determine si le click qui doit laisser fermer le message ou non (true=laisser ouvert, sinon=fermeture) */
        noCloseOnClick?: boolean;
        /** Optionel: provenance du message (permet de fermer tout les mnessages provenant d'une meme source, ex.: fermer les messages en lien avec un formulaire, sans fermer les autres) */
        messageSource?: string;
        /** Optionel: type du message (info, warning, error, success, etc.) */
        messageType?: MessageTypes;
        /** Optionel: statut du message (info, warning, error, success, etc.) */
        messageStatus?: MessageStatusTypes;
        /** Optionel: Fermeture automatique programmé */
        autoClose?: boolean;
        /** Optionel: date de publication */
        broadcastDateTime?: Date;
        /** Optionel: duree depuis la publication */
        timeSinceBroadcast?: string;
        /** Optionel: duree depuis la publication pour l'attribut 'title' */
        timeSinceBroadcastToolTip?: string;
    }

    export interface IMessagesManagerItem {
        /** Optionel: identifiant du message (sera automatiquement assigne si NULL) */
        id?: string;
        /** Optionel: date de creation (sera automatiquement assigne si NULL) */
        creationDate?: Date;
        /** Optionel: duree d'affichage du message avant que celui-ci ne se ferme automatiquement. Restera ouvert si NULL. */
        durationMs?: number;
        /** Optionel: titre du message */
        title?: string;
        /** Optionel: contenu RTF (HTML) */
        contentHtml?: string;
        /** Optionel: url du lien */
        linkUrl?: string;
        /** Optionel: text du lien */
        linkText?: string;
        /** Optionel: determine si le lien doit etre ouvert dans un nouvel onglet (target='_blank') */
        linkAsBlank?: boolean;
        /** Optionel: url du click du message */
        clickUrl?: string;
        /** Optionel: attribut HTML 'title' au 'hover' du message  */
        clickToolTip?: string;
        /** Optionel: determine si le click doit ouvrir l'url dans un nouvel onglet (target='_blank') */
        clickAsBlank?: boolean;
        /** Optionel: determine si le click qui doit laisser fermer le message ou non (true=laisser ouvert, sinon=fermeture) */
        noCloseOnClick?: boolean;
        /** Optionel: provenance du message (permet de fermer tout les mnessages provenant d'une meme source, ex.: fermer les messages en lien avec un formulaire, sans fermer les autres) */
        messageSource?: string;
        /** Optionel: type du message (info, warning, error, success, etc.) */
        messageType?: MessageTypes;
        /** Optionel: statut du message (info, warning, error, success, etc.) */
        messageStatus?: MessageStatusTypes;
    }

    /** Utilise pour les la gestion des hot editable selects interdependants */
    export interface ISelectOptionsParent {
        /** correspond a la categorie parent */
        parent: ISelectOption;
        /** correspond a la liste des enfants possible pour la categorie parent assiociee */
        children: ISelectOption[];
    }

    /** Utilise pour les la gestion des hot editable selects interdependants */
    export interface ISelectOption {
        /** label affiche */
        name: string;
        /** Optionel: valeur */
        value?: string;
        /** Optionel: determine si l'option est 'selected' */
        isSelected?: boolean;
    }

    export interface IHotEditableFormResponseData extends IHotEditableFormConfig, IResponseDataGlobal {
        bag?: IBag;
        redirectUrl?: string;
        redirectUrlOptions?: urlOptions[];
        forceRedirectOnDeleteAction?: boolean;
        updatedConcurrencySumCheck?: string;
        fieldsToUpdate?: IHotEditableUpdateField[];
        /** Collection ordonnee par 'IHotEditableFormConfirmationMessage.date' OR 'Date.minValue'. */
        confirmationMessages?: IHotEditableFormConfirmationMessage[];
        hotEmbeddedComponentsToUpdate?: IEmbeddedComponentToUpdate[];
        refreshBrotherEmbeddedComponents?: boolean;
        restoreBrotherEmbeddedComponents?: boolean;
        ensureBrotherEmbeddedComponentsIsDefaultUrl?: boolean;
        scrollToTopOnSuccess?: boolean;
    }

    export interface IHotEditableFormConfig {
        /** ATTENTION: est aussi definie par les APIs via les 'FunctionalExceptions' */
        disableAutomaticMessages?: boolean;
        disableAllMessages?: boolean;
        messages?: IHotEditableCustomMessage[];
    }

    export interface IResponseDataGlobal {
        outdatedContent?: IHotEditableOutdatedContent;
    }

    export interface IHotEditableCustomMessage {
        text: string;
        name?: string;
        messageType?: MessageTypes;
        autoClose?: boolean;
    }

    export interface IHotEditableOutdatedContent {
        /** Determine si une page entiere doit etre rafraichit en entier via la popup de refresh. */
        refreshEntirePage?: boolean;
        /** Determine si un widget (embedded content) doit etre rafraichit via la popup de refresh. Laisser NULL et RefreshEntirePage=FALSE pour identifier le current widget comme etant le widget a rafraichir. */
        hotEmbeddedComponentsToRefresh?: IEmbeddedComponentToUpdate[];
        CustomRefreshTitleHtml?: string;
        CustomRefreshMessageHtml?: string;
    }

    /** Permet d'identifier un component en vue de le mettre a jour */
    export interface IEmbeddedComponentToUpdate {
        url: string;
        name: string;
        editModeOn: boolean;
    }

    export interface IHotEditableFormConfirmationMessage {
        key: string;
        date: Date;
        titleHtml?: string;
        contentHtml?: string;
        /** reset=systemCode.unset */
        reset?: boolean;
        validated?: boolean;
        hideDeniedButton?: boolean;
        returnToApiOnDenied?: boolean;
        systemCode?: string;
    }
    export interface IHotEditableUpdateField {
        name: string;
        value?: string;
        valueOptions?: string;
        /** Aucun changement si NULL */
        disabled?: boolean;
    }
    export interface IHotEditableAdditionalFieldContent {
        value: string;
        valueType?: HotEditableAdditionalFieldContentValueTypes;
        isPermanent?: boolean;
    }

    /**
     * Vue-class-component: 
     * 1. Les proprietes "private" doivent rester "public" (prefixer simplement par _, ex.: _maProp). 
     * 2. Les proprietes qui sont definies dans "beforeCreate" doivent etre initialement ("undefined", meme pas NULL).
     * 3. Les proprietes qui sont definies dans "create" doivent etre definie initialement (au minimum par un NULL).
     */
    export interface IHotEditableFieldComponent {
        editClick?(event?: Event, forcedMode?: boolean, fromPrevious?: boolean): void;
        changeMode?: (canChangeEditMode: boolean, editModeOn: boolean) => void;
        changed?(): void;
        cancel?(): void;
        focus?(fromPrevious?: boolean): void;
        blur?(): void;
        clear?(): void;
        isHidden?(value?: boolean): boolean;
        getTextualValue(): string;
        setFromTextualValue(textualValue?: string): IHotEditableFieldComponent;
        isSameElementValue?(a: any, b: any): boolean;
        copyElementValue?(): any;
        /** this.elementValue=this.previousValue et retourne TRUE si un changement a ete applique */
        revertLastChanges?(): boolean;
        revertLastChangesOnConfirmationRejected?: boolean;
        fieldType: HotEditableFieldTypes;
        idElement: string;
        elementName: string;
        elementValue: any;
        disabled?: boolean;
        required?: boolean;
        clearable?: boolean;
        tabIndex?: number;
        editModeOn?: boolean;
        canChangeEditMode?: boolean;
        defaultValue?: any;
        displayName?: string;
        isParent?: boolean;
        hasError?: boolean;
    }

    export interface IHotEditableFormParentVue {
        culture?: Cultures;
        /** methodes partagees */
        shared: SharedHotEditableParentForm;
        /** Optionel: mode du formulaire */
        formMode?: HotEditableFormModes;
        /** Optionel: determine si le boutton crayon (qui toggle le 'formMode') est visible ou non */
        isVisibleToggleButton?: boolean;
        /** Permet de gerer manuellement les boutons du formulaires lors des changements de mode de formulaire (original/edition) */
        destroyComponents?(): IHotEditableFormParentVue;
        manageButtonsOnFormModeChange?(): boolean;
        refreshForceUpdate?(): void;
    }

    /** Option du select du plugin 'vue-select' */
    interface IVueSelectOption {
        /** Label affiche */
        label: string;
        /** valeur de l'option */
        code: string;
    }

    export interface IHotEditableSelectOption extends IVueSelectOption {
        //conserver cette interface
    }

    export interface ISearchSorter {
        fieldName: string;
        order: string;
        sorterType: string;
    }
    export interface ISearchFilter {
        fieldName: string;
        values: string[];
    }
    export interface ISearchParameters {
        termsMode: string;
        pageSize: number;
        pageNumber: number;
        originalTerms: string;
        terms: string[];
        sorters: ISearchSorter[];
        filters: ISearchFilter[];
        termsClause: string;
        filterGroupsClause: string;
        filterValuesClause: string;
        termsSearchedFields: string[];
    }

    export interface IActionToolTipMapping {
        actionType: ToolsBarActionTypes;
        enableToolTip: string;
        disableToolTip: string;
    }

    export interface IPosition {
        top: number;
        left: number;
    }

    /** Identifie un item selection par sont type et sont ID. Generalement utilise dans le SearchBox */
    export interface ISelectedItem {
        id: string;
        type: string;
    }

    export interface ISearchBoxArguments {
        formName: string;
        searchParameters: ISearchParameters;
        currentSearchContext: string;
        toolsBarActionArguments: IToolsBarActionArguments;
        currentUrl: string;
        focusedItemId: string;
        isInitialCall: boolean;
        performExport?: boolean;
        customData?: IPostCustomData;
    }

    export interface ISearchBoxFilter {
        name: string;
        value: string;
    }

    export interface ISearchBoxPreconfiguredFiltersSettings {
        clearTermsOnApply?: boolean;
        filters: ISearchBoxPreconfiguredFilters[];
    }
    export interface ISearchBoxPreconfiguredFilters {
        title: string;
        name: string;
        id: string;
        count: number;
        order: number;
        filters: ISearchBoxFilter[];
        children?: ISearchBoxPreconfiguredFilters[];
        childrenState?: CollapsorStates;
    }

    export interface IFetchArgs {
        userId: string;
        lastPoolingDate: string;
        poolingDate: string;
        currentUrl: string;
    }

    export interface IToolsBarActionArguments {
        type: ToolsBarActionTypes;
        selectedItems: ISelectedItem[];
        isCtlClick: boolean;
    }

    export interface IBag {
        raw: Object;
    }
    export interface INote {
        id: string;
        title: string;
        description: string;
        date: string;
        dateRaw: string;
        icon: string;
        author: string;
        comments: INoteCommentaire[];
        /** Adding/Editing */
        currentlyEditingItem?: boolean;
        currentlyAddingComment?: boolean;
        commentNewText?: string;
    }
    export interface INoteCommentaire {
        idNote: string;
        id: string;
        author: string;
        text: string;
        textRaw: string;
        date: string;
        dateRaw: string;
        currentlyEditingComment?: boolean;
        editedText?: string;
    }

    export interface ISearchBoxResult {
        model: any;
        type: string;
        uid: string;
        id: string;
        clickUrl: string;
        selected: boolean;
        isVisible?: boolean;
        searchBoxSelectField?: ISearchBoxSelectField;
        groupPosition?: string; //Options: first, middle, last or null
    }

    export interface ISearchBoxSelectField {
        groupName: string;
        isChecked: boolean;
        id: string;
    }

    export interface ISearchBoxConfig {
        /** Settings du searchbox (requis si "enableSearchBox" vaut TRUE) */
        searchBoxSettings?: ISearchBoxSettings;
        /** Valeur de l'attribut HTML "name" du formulaire contenant les champs des filtres du searchbox */
        filtersFormName?: string;
    }

    export interface ISearchBoxSettings {
        /** Utilise lors de la reinitialisation (optional) */
        searchParameters: ISearchParameters;
        searchBoxContext: ISearchBoxContext;
        defaultSeachFilters?: ISearchFilter[];
        openFiltersOnInit?: boolean;
        goToServerOnItemClick?: boolean;
        /** Affiche les filtres */
        hasFilters?: boolean;
        /** Affiche les termes */
        hasTerms?: boolean;
        enableExport?: boolean;
        focusedItemId?: string;
        customData?: IPostCustomData;
        actions?: ISearchBoxAction[];
        defaultNoResultText?: string;
    }

    export interface ISearchBoxContext {
        name: string;
        id: string;
        maxItems: number;
        focusedItemId: string;
        isOnPoolingActive: boolean;
        itemsCounterConfig?: ISearchBoxContextItemsCounterConfig;
    }

    export interface ISearchBoxContextItemsCounterConfig {
        textFormat?: string; //Placeholders : {number}, {total}
        counterTarget?: string;
    }

    export interface ISearchBoxResponseData {
        searchResults: ISearchBoxResult[];
        searchParameters: ISearchParameters;
        cancelDataUpdate: boolean;
        totalItems: number;
        actionData: IToolsBarActionResponseData;
        noResultText?: string;
        updatedUrl?: string;
        maxModifiedResultDateUtc?: string;
        focusedItemId?: string;
        exportUrl?: string;
        displayExportButton?: boolean;
        /** Collection ordonnee par 'IHotEditableFormConfirmationMessage.date' OR 'Date.minValue'. */
        confirmationMessages?: IHotEditableFormConfirmationMessage[];
    }
    export interface ISearchBoxHeaderInitialData {
        searchBox: SearchBox,
        el: string,
        formName: string,
        openFiltersOnInit: boolean,
        actions: ISearchBoxAction[]
    }
    export interface ISearchBoxResultsInitialData {
        searchBox: SearchBox,
        el: string,
        formName: string,
        defaultNoResultText: string,
        goToServerOnItemClick: boolean,
        actions: ISearchBoxAction[]
    }

    export interface IToolsBarActionResponseData {
        performSearch: boolean;
        redirectUrl: string;
        redirectUrlInNewTab: boolean;
        redirectPostData: any;
        successMessage: string;
        updatedActions: IToolsBarUpdatedAction[];
    }

    export interface IToolsBarUpdatedAction {
        type: string;
        isVisible: boolean;
    }

    export interface IWebComponent {
        init: (settings: any) => void;
        destroy?: () => void;
        componentType?: string;
        setSharedEmbeddedParentForm?(shared: SharedEmbeddedParentForm): IWebComponent;
        insertNavContextHiddenField?(navContextId: string): IWebComponent;
        refreshEmbeddedComponents?(): void;
    }

    export interface IWebServiceContext {
        apiCultureFormatUrl: string;
        poolingApiUrl: string;
        searchApiUrl: string;
        openNotificationsApiUrl: string;
        updateAllNotificationsAsRead: string;
        updateAllNotificationsAsDeleted: string;
        updateNotificationsAsRead: string;
        updateNotificationsAsDeleted: string;
        mapaqChargementManuel: string;
        getFermeApiUrl: string;
        // donneesReferentiellesSauvegarderApiUrl: string;
        // municipalitesSauvegarderApiUrl: string;
        // communautesMetropolitainesSauvegarderApiUrl: string;
        // territoiresSauvegarderApiUrl: string;
        // regionsAdministrativesSauvegarderApiUrl: string;
        // arrondissementsSauvegarderApiUrl: string;
        // regroupementsRegionsAdministrativesSauvegarderApiUrl: string;
        // municipalitesDesignationsSauvegarderApiUrl: string;
        // federationsRegionalesSauvegarderApiUrl: string;
        // syndicatsRegionauxSauvegarderApiUrl: string;
        // municipalitesRegionalesComtesSauvegarderApiUrl: string;
        // utilisateurSecuriteSauvegarderApiUrl: string;
    }

    export interface IEnvContext {
        currentVersion: string;
        currentIsLab: boolean;
        currentIsLocal: boolean;
        currentIsDev: boolean;
        currentIdentifier: string;
        browser: IBrowserContext;
        device: IDeviceContext;
    }

    export interface IDeviceContext {
        isMobile: boolean;
    }

    export interface IBrowserContext {
        isIe10OrLess: boolean,
        isIe11: boolean,
        isIe: boolean,
        isEdge: boolean,
        isFirefox: boolean,
        isSafarie: boolean,
        isOther: boolean,
        canSupportOptimalMode: boolean
    }

    /** Utilisation du LocalStorage */
    export interface IStorage {
        keys: any;
        clear: () => void;
        store: (key: string, value: any) => void;
        retrieve: (key: string) => any;
        storeObj: (key: string, value: any) => void;
        retrieveObj: (key: string) => any;
    }

    export interface IContext {
        user?: IUserContext;
        bag: Object;
        url: IUrlContext;
        culture: ICultureContext;
        webServices: IWebServiceContext;
        upload: IUploadContext;
        pooler: IPoolerContext;
        searchBox: ISearchBoxContext;
        env: IEnvContext;
        components: IComponentsContext;
        formats: IFormatsContext;
        storage: IStorage;
        resources: IResourcesContext;
        git: any;
        countryIds: any;
        reCaptcha?: IReCaptchaContext;
    }
    export interface IReCaptchaContext {
        actions: {};
        siteKey: string;
        isValidated?: boolean;
    }

    export interface IFormatsContext {
        dateMomentDetault: string;
        dateTimeMomentDetault: string;
        dateTimeMomentWithMs: string;
        textFormaters: ITextFormater[];
    }
    export interface ITextFormater {
        name: string;
        format: (x: string, data?: any) => string;
    }
    export interface IResourcesContext {
        UneErreurEstSurvenueSiVotreConnexionEstEchueVeuillezVousReconnecterDeNouveau: string;
    }

    export interface ICultureContext {
        name: string;
        get(defaultCulture?: common.Cultures): Cultures;
    }

    export interface IPoolerContext {
        messagesManagerPoolingFrequencySec: number;
        searchBoxPoolingFrequencySec: number;
        panneauAdminitrationPoolingFrequencySec: number;
    }

    export interface IUserContext {
        agent: string;
        connected: boolean;
        id: string;
        firstName?: string;
        lastName?: string;
    }

    export interface IComponentsContext {
        /** Dictionary<typeofWebComponent, webComponent> */
        items: {};
        add: (webComponent: IWebComponent) => IWebComponent;
        /** f: retourner TRUE pour faire un 'break'. */
        doForEarch: (f: (type: string, webComponent: common.IWebComponent, skipNullEntries?: boolean) => void | boolean) => void;
        getByType: (type: string, skipNullEntries?: boolean) => IWebComponent[];
        getPage: () => Page;
        getPooler: () => Pooler;
        getMessagesManager: () => MessagesManager;
        getNotifications: () => Notifications;
    }

    export interface IUrlContext {
        parameters: any;
        delimiters: any;
        values: any;
        placeholders: any;
    }

    export interface IUploadContext {
        defaultMaxFiles: number;
        defaultMaxFileSizeMb: number;
    }

    export interface IValidatedFiles {
        files: File[];
        hasMaxFilesError: boolean;
        hasMaxFileSizeMbErrors: boolean;
        maxFilesErrorMessage: string;
        maxFileSizeMbErrorMessages: string[];
    }


    /** Regle pour l'application des actions dans le SearchBox */
    export interface ISelectionRules {
        nothingSelect: string;
        singleSelect: string;
        multiSelect: string;
        nothingOrSingleSelect: string;
        nothingOrMultiSelect: string;
        bannerAction: string;
    }

    /** Reference d'un ou de plusieurs champs dans un formulaire. Generalement utilise pour associer un messages d'erreur a un ou plusieurs champs de formulaire. */
    export interface IFormFieldReference {
        formName: string;
        fieldConfigurations: IFormFieldReferenceConfiguration[];
    }
    export interface IFormFieldReferenceConfiguration {
        name: string;
        hideMessage: boolean;
    }

    export interface IError {
        code: number;
        message: string;
        isSystemError: boolean;
        formFieldReferences?: IFormFieldReference[];
        toObject(): any;
        toArray(): any[];
    }

    export interface IWarning extends IError { }

    export interface IResponseInfo {
        date: Date;
        dateUtc: string;
        hasError: boolean;
        hasWarning: boolean;
        errors: IError[];
        warnings: IWarning[];
    }

    export interface IResponse {
        info: IResponseInfo;
        data: any;
    }

    export interface IAllItemsLoadedValidationData {
        totalItems: number;
        pageSize: number;
        pageNumber: number;
    }

    export interface IMessageNotificationConfig {
        textTarget: string;
        closerTarget: string;
        rootCssClassesFormat?: string;
        initialDelay?: number;
        //default values
        defaultFocusMessage?: boolean;
        defaultFocusDelay?: number; //ms
        defaultFadeOutDelay?: number; //ms
        defaultFadeOutDuration?: number; //ms
        //ATTENTION: 'fixedIfNotVisible' ne fonctionne pas dans les listes Angular car il y a alteration du DOM a l'initialisation.
        fixedIfNotVisible: boolean;
        fixedCssClass: string;
        //methods
        getRootId(): string;
        setRootId(id: string): IMessageNotificationConfig;
    }

    export interface IMessageNotificationDisplayConfig {
        isHtmlMessage?: boolean;
        index?: number;
        focusMessage?: boolean;
        /** delai avant que la boite ne s'ouvre (millisecondes) */
        focusDelay?: number;
        /** delai avant que la boite ne se referme (millisecondes) */
        fadeOutDelay?: number;
        /** duree de la transition de fermeture de la boite (millisecondes) */
        fadeOutDuration?: number;
    }

    export interface IMessageNotification {
        getConfig(): IMessageNotificationConfig;
        setConfig(config: IMessageNotificationConfig): IMessageNotification;
        reset(fadeOutDuration?: number): IMessageNotification;
        displayErrors(
            errors: IError[],
            includeErrorCode?: boolean,
            focusMessage?: boolean,
            focusDelay?: number
        ): IMessageNotificationConfig;
        displaySuccessMessages(
            messages: string[],
            focusMessage?: boolean,
            focusDelay?: number
        ): IMessageNotification;
        displayErrorMessages(
            messages: string[],
            focusMessage?: boolean,
            focusDelay?: number
        ): IMessageNotification;
        displayWarningMessages(
            messages: string[],
            focusMessage?: boolean,
            focusDelay?: number
        ): IMessageNotification;
        displaySuccessMessage(
            message: string,
            config?: IMessageNotificationDisplayConfig
        ): IMessageNotification;
        displayErrorMessage(
            message: string,
            config?: IMessageNotificationDisplayConfig
        ): IMessageNotification;
        displayWarningMessage(
            message: string,
            config?: IMessageNotificationDisplayConfig
        ): IMessageNotification;
    }

    export interface IInitializeAllCheckboxesConfig {
        //rootTarget = selecteur du scope d'initialisation, habituellement 'null' pour toute la page.
        rootTarget?: string;
        //modTarget = selecteur du module de checkbox, habituellement '.mod-checkbox'.
        modTarget?: string;
        forceReinitAll?: boolean;
        forceReinit?: (instance: any) => boolean;
        onChangeAction?: (instance: any) => void;
        onCheckAction?: (instance: any) => void;
        onPreInit?: (instance: any) => void;
        onInitCompleted?: (instance: any) => void;
    }

    export interface IInitializeAllRadiobuttonsConfig {
        modTarget?: string;
        forceReinitAll?: boolean;
        forceReinit?: (instance: any) => boolean;
        onChangeAction?: (instance: any) => void;
        onCheckAction?: (instance: any) => void;
        onPreInit?: (instance: any) => void;
        onInitCompleted?: (instance: any) => void;
    }

    export interface IInitializeBoxCollapsorConfig {
        modTarget?: string;
        buttonTarget?: string;
        buttonAltTarget?: string;
        boxTarget?: string;
        buttonIsOutside?: boolean;
        buttonAltIsOutside?: boolean;
        onChangeState?: (
            state: string,
            $mod: JQuery,
            $box: JQuery,
            $button: JQuery
        ) => void;
    }
}

export = common;
